import { render, staticRenderFns } from "./201Files.vue?vue&type=template&id=4c55a9c2&scoped=true"
import script from "./201Files.vue?vue&type=script&lang=js"
export * from "./201Files.vue?vue&type=script&lang=js"
import style0 from "./201Files.vue?vue&type=style&index=0&id=4c55a9c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c55a9c2",
  null
  
)

export default component.exports